import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import {
    SCREENSHOT_LANG_CODES,
    appendScreenshotLang,
    useScreenshotTranslation,
} from "../lib/screenshotI18n";

const LANG_LABELS = {
    english: "English",
    french: "Français",
    spanish: "Español",
    german: "Deutsch",
    portuguese: "Português",
    japanese: "日本語",
    korean: "한국어",
    chinese: "中文",
    arabic: "العربية",
    hindi: "हिन्दी",
};

/** Language switcher for screenshot index pages — adds `?lang=` to the current path. */
export default function ScreenshotLangPicker({ sx } = {}) {
    const { t, lang } = useScreenshotTranslation();
    const { pathname, search } = useLocation();

    return (
        <Box sx={{ mb: 2, ...sx }}>
            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.75 }}>
                {t("mobileScreenshot.common.lang-label")}
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
                {Object.entries(SCREENSHOT_LANG_CODES).map(([langKey, code]) => {
                    const selected = langKey === lang;
                    return (
                        <Chip
                            key={langKey}
                            component={RouterLink}
                            to={appendScreenshotLang(`${pathname}${search}`, langKey)}
                            clickable
                            size="small"
                            label={LANG_LABELS[langKey] ?? code}
                            color={selected ? "primary" : "default"}
                            variant={selected ? "filled" : "outlined"}
                            sx={{
                                fontWeight: selected ? 700 : 500,
                                textDecoration: "none",
                                "&:hover": { textDecoration: "none" },
                            }}
                        />
                    );
                })}
            </Box>
        </Box>
    );
}
